module.exports = __webpack_public_path__ + "static/media/ic_launcher.58bd4b9f.png";